import { API_URL } from "../config/config";
import { deleteRequest, getRequest, postRequest, putRequest } from "../utils/axiosUtils";
import buildQueryParams from "../utils/buildQueryParams";


export const addOrUpdateExpense = async (payload, isEditMode = false) => {
    try {

        const res = isEditMode ?
            await putRequest({
                url: `${API_URL}/admin/expense/edit/${payload?._id}`,
                data: payload,
            })
            : await postRequest({
                url: `${API_URL}/admin/expense/save`,
                data: payload,
            });

        if (res.status >= 200 && res.status < 300 && res.data) {
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (err) {
        console.error('Error adding expense:', err);
        throw new Error(err?.response?.data?.message || `Failed to ${isEditMode ? "update" : "add"} expense`);
    }
};

export const fetchExpensesList = async ({ filter = {}, setExpenseList }) => {
    try {
        const queryParams = buildQueryParams(filter)
        const res = await getRequest({
            url: `${API_URL}/admin/expense/all?${queryParams}`,
        });
        if(!res) return

        if (res.status >= 200 && res.status < 300 && res.data) {
            setExpenseList(res?.data?.data);
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (error) {
        throw new Error(error?.message || "Failed to fetch expense list");
    }
};

export const deleteExpense = async (id) => {
    try {

        const res =
            await deleteRequest({
                url: `${API_URL}/admin/expense/delete/${id}`,
            })

        if (res.status >= 200 && res.status < 300 && res.data) {
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (err) {
        console.error('Error adding expense:', err);
        throw new Error(err?.response?.data?.message || `Failed to delete expense`);
    }
};